import React from 'react';
import { connect } from 'react-redux';

import {
  verifyPhone,
  resendPhoneVerification
} from 'legacy/actions/userActions';
import {
  verifyOrgPhone,
  resendOrgPhoneVerification
} from 'legacy/actions/orgActions';

import ModalBase from '../ModalBase/ModalBase';
import VerifyPhoneForm from './components/VerifyPhoneForm';
import { BaseModalProps } from '../ModalBase/ModalBase';
import { PhoneUser, LoadingState } from '../types';

interface VerifyPhoneProps {
  loading: LoadingState;
  error?: string;
  user: PhoneUser;
  verifyPhone: (code: string) => void;
  baseModalProps: BaseModalProps;
  onSuccess?: () => void;
  resendPhoneVerification: () => void;
  verifyOrgPhone: (orgId: string, code: string) => void;
  resendOrgPhoneVerification: (orgId: string) => void;
  orgId?: string;
  overrideBaseModalProps?: any;
  verifyActionType: string;
  resendActionType: string;
}

function VerifyPhone({
  loading,
  error,
  user,
  verifyPhone,
  baseModalProps,
  onSuccess,
  resendPhoneVerification,
  verifyOrgPhone,
  resendOrgPhoneVerification,
  orgId,
  overrideBaseModalProps,
  verifyActionType,
  resendActionType
}: VerifyPhoneProps) {
  const handleSubmit = (code: string) => {
    if (orgId) {
      verifyOrgPhone(orgId, code);
    } else {
      verifyPhone(code);
    }
  };

  const handleResend = () => {
    if (orgId) {
      resendOrgPhoneVerification(orgId);
    } else {
      resendPhoneVerification();
    }
  };

  return (
    <ModalBase
      baseModalProps={baseModalProps}
      contentClassName="basic"
      hideBackButton
      {...overrideBaseModalProps}
    >
      <VerifyPhoneForm
        user={user}
        loading={loading}
        error={error}
        verifyActionType={verifyActionType}
        onVerifyPhone={handleSubmit}
        resendActionType={resendActionType}
        onResend={handleResend}
        onSuccess={onSuccess}
      />
    </ModalBase>
  );
}

const actions = {
  verifyPhone,
  resendPhoneVerification,
  verifyOrgPhone,
  resendOrgPhoneVerification
};

const mapStateToProps = (state: any, { orgId }: { orgId?: string }) => {
  const selector = orgId ? 'orgs' : 'user';
  const verifyActionType = orgId ? 'VERIFY_ORG_PHONE' : 'VERIFY_PHONE';
  const resendActionType = orgId ? 'VERIFY_ORG_PHONE' : 'VERIFY_PHONE';
  return {
    user: orgId ? state.orgs.orgs[orgId] : state.user.user,
    error: state[selector].errors[verifyActionType].message,
    loading: state[selector].loading,
    verifyActionType,
    resendActionType
  };
};

export default connect(mapStateToProps, actions)(VerifyPhone);
